import NewPost from './NewPost';

export default NewPost; 